import { ILLProductBase } from "./ll-product-base.model";


export class IBNCCEstablishment {
    establishmentId: number;
    establishmentName: string;
    establishmentDUNS: string;
    sortOrder: number;
    bnccRevisionId: number;
    isManualEntry: boolean;
    product: ILLProductBase;
}
